export default __webpack_public_path__ + "static/media/xperience_rebrand_logo_mobile.9a23a388.svg";